"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useWaveRankReward } from "@/hooks/waves/useWaveRankReward";
interface WaveWinnersSmallOutcomeProps {
  readonly drop: ExtendedDrop;
}
export const WaveWinnersSmallOutcome: React.FC<WaveWinnersSmallOutcomeProps> = t0 => {
  const $ = _c(49);
  const {
    drop
  } = t0;
  const [isTouch, setIsTouch] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouch("ontouchstart" in window);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isOpen || $[3] !== isTouch) {
    t3 = e => {
      if (isTouch) {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }
    };
    $[2] = isOpen;
    $[3] = isTouch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClick = t3;
  let t4;
  if ($[5] !== drop.rank || $[6] !== drop.wave.id) {
    t4 = {
      waveId: drop.wave.id,
      rank: drop.rank
    };
    $[5] = drop.rank;
    $[6] = drop.wave.id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    nicTotal,
    repTotal,
    manualOutcomes
  } = useWaveRankReward(t4);
  if (!(nicTotal || repTotal || manualOutcomes.length)) {
    return null;
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">Outcome Details</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#A4C2DB]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M9 6.75H15M9 12H15M9 17.25H12M3.75 19.5H20.25C21.0784 19.5 21.75 18.8284 21.75 18V6C21.75 5.17157 21.0784 4.5 20.25 4.5H3.75C2.92157 4.5 2.25 5.17157 2.25 6V18C2.25 18.8284 2.92157 19.5 3.75 19.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">NIC</span></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== nicTotal) {
    t7 = formatNumberWithCommas(nicTotal);
    $[10] = nicTotal;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-bg-iron-800/40 tw-p-2">{t6}<span className="tw-text-sm tw-font-semibold tw-text-[#A4C2DB]">{t7}</span></div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#C3B5D9]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" stroke="currentColor" strokeWidth="1.5" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">Rep</span></div>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== repTotal) {
    t10 = formatNumberWithCommas(repTotal);
    $[15] = repTotal;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <div className="tw-flex tw-flex-col tw-gap-y-1 tw-rounded-lg tw-bg-iron-800/40 tw-p-2"><div className="tw-flex tw-items-center tw-justify-between">{t9}<span className="tw-text-sm tw-font-semibold tw-text-[#C3B5D9]">{t10}</span></div></div>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== manualOutcomes) {
    t12 = manualOutcomes.map(_temp);
    $[19] = manualOutcomes;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12 || $[23] !== t8) {
    t13 = <div className="tw-space-y-3 tw-rounded-xl tw-border tw-border-iron-800/60 tw-bg-iron-900/95 tw-p-3.5 tw-shadow-[0_8px_32px_rgba(0,0,0,0.35)] tw-backdrop-blur-xl lg:tw-min-w-[220px]"><div className="tw-space-y-2.5">{t5}<div className="tw-space-y-2">{t8}{t11}{t12}</div></div></div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const tooltipContent = t13;
  let t14;
  if ($[25] !== handleClick) {
    t14 = e_0 => {
      e_0.stopPropagation();
      handleClick(e_0);
    };
    $[25] = handleClick;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = `outcome-small-${drop.id}`;
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="tw-text-xs tw-font-normal tw-text-iron-200">Outcome:</span>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== nicTotal) {
    t17 = !!nicTotal && <svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#A4C2DB]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M9 6.75H15M9 12H15M9 17.25H12M3.75 19.5H20.25C21.0784 19.5 21.75 18.8284 21.75 18V6C21.75 5.17157 21.0784 4.5 20.25 4.5H3.75C2.92157 4.5 2.25 5.17157 2.25 6V18C2.25 18.8284 2.92157 19.5 3.75 19.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[28] = nicTotal;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== repTotal) {
    t18 = !!repTotal && <svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#C3B5D9]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" stroke="currentColor" strokeWidth="1.5" /></svg>;
    $[30] = repTotal;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== manualOutcomes.length) {
    t19 = !!manualOutcomes.length && <svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#D4C5AA]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M12 18v-3m0-3v.01M12.75 3.25h-1.5L8.5 7H4.75l.5 3.5L2 13l3.25 2.5-.5 3.5h3.75l2.75 3.75h1.5L15.5 19h3.75l-.5-3.5L22 13l-3.25-2.5.5-3.5H15.5l-2.75-3.75z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[32] = manualOutcomes.length;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t18 || $[36] !== t19) {
    t20 = <div className="tw-flex tw-items-center tw-gap-2">{t17}{t18}{t19}</div>;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t14 || $[39] !== t15 || $[40] !== t20) {
    t21 = <button onClick={t14} className="tw-flex tw-min-w-6 tw-items-center tw-gap-2 tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-px-2 tw-py-1.5 tw-ring-1 tw-ring-iron-700" data-tooltip-id={t15}>{t16}{t20}</button>;
    $[38] = t14;
    $[39] = t15;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  const t22 = `outcome-small-${drop.id}`;
  let t23;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t22 || $[44] !== tooltipContent) {
    t24 = <Tooltip id={t22} place="top" delayShow={200} style={t23}>{tooltipContent}</Tooltip>;
    $[43] = t22;
    $[44] = tooltipContent;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t21 || $[47] !== t24) {
    t25 = <>{t21}{t24}</>;
    $[46] = t21;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
};
function _temp(outcome) {
  return <div key={`manual-${outcome}`} className="tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-bg-iron-800/40 tw-p-2"><div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#D4C5AA]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M12 18v-3m0-3v.01M12.75 3.25h-1.5L8.5 7H4.75l.5 3.5L2 13l3.25 2.5-.5 3.5h3.75l2.75 3.75h1.5L15.5 19h3.75l-.5-3.5L22 13l-3.25-2.5.5-3.5H15.5l-2.75-3.75z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">{outcome}</span></div></div>;
}